/** Defaults alineados con docs/agentes/FICHA-CLIENTE-PLANTILLA.md */

export const EMPTY_IDENTIDAD = {
  frase: "",
  targetEdadMindset: "",
  ocasionUso: "",
  sensacionDeseada: "",
  rechaza: "",
  precioPercibido: "",
  posicionamiento: "premium comercial",
  mantrasSi: "",
  prohibidos: "",
  lineaVsPremium: "",
  links: "",
};

export const EMPTY_VISUAL = {
  coloresCore: "",
  coloresTemporada: "",
  coloresVeto: "",
  prints: "",
  logoPlacement: "",
  materialesSi: "",
  materialesNo: "",
  hardwareDetalles: "",
  tipografiaLogo: "",
};

export const EMPTY_PRODUCTO = {
  tipologiasMarcadas: "",
  tipologiasDetalle: "",
  checklistMarca: "",
};

export const EMPTY_MEMORIA = {
  learnings: "",
  refsClave: "",
  produccion: "",
  canalRetail: "",
};

export const EMPTY_AGENTE = {
  entregables: "",
  formatoSalida: "",
  preguntasPrevias: "",
  ordenTrabajo: "",
};

export const EMPTY_BUENOS_MALOS = {
  buenos: "",
  malos: "",
  fraseOro: "",
};

export const EMPTY_CHECKLIST = {
  items: `Parece la marca sin leer el logo
Encaja tipología pedida
Respeta línea de marca
Coherente con temporada / cápsula
Tiene ancla en historial STAGE
Es producible con constraints
Formato de entrega correcto`,
};

export const EMPTY_CIERRE = {
  listaParaSkill: false,
  adjuntos: "",
  comentario: "",
};

export const STATUS_OPTIONS = [
  { value: "draft", label: "Borrador" },
  { value: "design_done", label: "Terminada por Diseño" },
  { value: "ready", label: "Lista para skill" },
  { value: "skill_created", label: "Skill creado" },
];

export function slugifySkill(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 120);
}

export function buildEmptyForm() {
  return {
    SkillSlug: "",
    Titulo: "",
    CustomerId: "",
    MarcaId: "",
    CodCli: "",
    CategoriaFoco: "",
    TemporadaRef: "",
    IdiomaEntregables: "ES",
    Status: "draft",
    IdentidadJson: { ...EMPTY_IDENTIDAD },
    UniversoVisualJson: { ...EMPTY_VISUAL },
    ProductoJson: { ...EMPTY_PRODUCTO },
    MemoriaStageJson: { ...EMPTY_MEMORIA },
    AgenteWorkJson: { ...EMPTY_AGENTE },
    BuenosMalosJson: { ...EMPTY_BUENOS_MALOS },
    ChecklistJson: { ...EMPTY_CHECKLIST },
    CierreJson: { ...EMPTY_CIERRE },
    CabeceraJson: {},
  };
}

export function hydrateForm(apiRow) {
  const empty = buildEmptyForm();
  if (!apiRow) return empty;
  return {
    ...empty,
    ...apiRow,
    CustomerId: apiRow.CustomerId ?? "",
    MarcaId: apiRow.MarcaId ?? "",
    IdentidadJson: { ...EMPTY_IDENTIDAD, ...(apiRow.IdentidadJson || {}) },
    UniversoVisualJson: {
      ...EMPTY_VISUAL,
      ...(apiRow.UniversoVisualJson || {}),
    },
    ProductoJson: { ...EMPTY_PRODUCTO, ...(apiRow.ProductoJson || {}) },
    MemoriaStageJson: {
      ...EMPTY_MEMORIA,
      ...(apiRow.MemoriaStageJson || {}),
    },
    AgenteWorkJson: { ...EMPTY_AGENTE, ...(apiRow.AgenteWorkJson || {}) },
    BuenosMalosJson: {
      ...EMPTY_BUENOS_MALOS,
      ...(apiRow.BuenosMalosJson || {}),
    },
    ChecklistJson: { ...EMPTY_CHECKLIST, ...(apiRow.ChecklistJson || {}) },
    CierreJson: { ...EMPTY_CIERRE, ...(apiRow.CierreJson || {}) },
    CabeceraJson: apiRow.CabeceraJson || {},
  };
}

export function toPayload(form) {
  return {
    SkillSlug: form.SkillSlug,
    Titulo: form.Titulo,
    CustomerId: form.CustomerId === "" ? null : form.CustomerId,
    MarcaId: form.MarcaId === "" ? null : form.MarcaId,
    CodCli: form.CodCli || null,
    CategoriaFoco: form.CategoriaFoco || null,
    TemporadaRef: form.TemporadaRef || null,
    IdiomaEntregables: form.IdiomaEntregables || null,
    Status: form.Status || "draft",
    CabeceraJson: {
      ...(form.CabeceraJson || {}),
      titulo: form.Titulo,
      categoria: form.CategoriaFoco,
      temporada: form.TemporadaRef,
      idioma: form.IdiomaEntregables,
    },
    IdentidadJson: form.IdentidadJson,
    UniversoVisualJson: form.UniversoVisualJson,
    ProductoJson: form.ProductoJson,
    MemoriaStageJson: form.MemoriaStageJson,
    AgenteWorkJson: form.AgenteWorkJson,
    BuenosMalosJson: form.BuenosMalosJson,
    ChecklistJson: form.ChecklistJson,
    CierreJson: form.CierreJson,
  };
}
